import { Provider } from '@angular/core';
import { provideMenuItemRefresher } from '@frontend-site/main-header/domain';
import { HybridMessagePayloadService } from '@frontend-site/shared/hybrid';
import { entitySaveCompleted$ } from '@frontend-site/shared/core';

export const menuItemRefresherProviders: Provider[] = [
    provideMenuItemRefresher(entitySaveCompleted$),
    provideMenuItemRefresher({ useFactory: menuItemRefresherFactory, deps: [HybridMessagePayloadService] })
];

function menuItemRefresherFactory(hybridMessagePayloadService: HybridMessagePayloadService) {
    return hybridMessagePayloadService.updateMyItems$;
}
